// AppCard.jsx
import { Badge, Text } from '@flatfile/baseline'
import { AppCTAs } from './AppCTAs'
import { AppOption } from './utilities/appOptions'

// Define props for AppCard component
interface AppCardProps {
  app: AppOption
  onAnyAction?: () => void
}

// AppCard component with typed props
export const AppCard: React.FC<AppCardProps> = ({ app, onAnyAction }) => (
  <div className='border rounded-lg bg-base-white overflow-hidden flex flex-col h-full'>
    <div>
      {/* Image with no padding */}
      <div className='w-full h-[250px] flex justify-center bg-[#F9F9FA] overflow-hidden border-b'>
        <img src={app.imageUrl} alt={app.title} className={`w-full object-cover object-top'}`} />
      </div>

      {/* Content area with padding */}
      <div className='p-2'>
        <div className='flex justify-between items-start mb-2'>
          <Text variant='title3' emphasized>
            {app.title}
          </Text>
          {app.id === 'autobuild' && (
            <Badge variant='secondary' radius='full' className='flex-shrink-0'>
              Recommended
            </Badge>
          )}
        </div>
        <Text variant='callout' className='text-text-default'>
          {app.description}
        </Text>
      </div>
    </div>

    {/* Divider */}
    <div className='mt-auto'>
      <div className='border-t border-gray-200'></div>
      <div className='p-3 flex justify-end'>
        <div className='app-cta-wrapper'>
          <AppCTAs
            appType={app.appType}
            learnMoreLink={app.learnMoreLink}
            onAnyAction={onAnyAction}
            isAutobuild={app.id === 'autobuild'}
            isFlatfileOs={app.id === 'flatfileOs'}
          />
        </div>
      </div>
    </div>
  </div>
)
